import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { getAvailableLanguages, changeLanguage } from "../../../../../i18n";

const LanguageSelect = ({ showLanguageSelect }) => {
  const { i18n } = useTranslation();
  const [selectedLang, setSelectedLang] = useState(i18n.language || 'ko');
  const [isLoading, setIsLoading] = useState(false);

  const goback = "/images/mo/x_back.svg";

  // 사용 가능한 언어 목록 (동기적으로 가져옴)
  const languages = getAvailableLanguages();

  const handleLanguageChange = (langCode) => {
    setIsLoading(true);
    try {
      setSelectedLang(langCode);
      changeLanguage(langCode);

      // 페이지 새로고침하여 번역 적용
      window.location.reload();
    } catch (error) {
      console.error('Failed to change language:', error);
      setIsLoading(false);
    }
  };

  return (
    <div className="absolute top-0 w-full h-full bg-[#F1F2F3] z-50 overflow-y-auto">
      <div className="w-full flex flex-col bg-[#FAFCFF]">
        <div className="flex justify-between items-center py-5 px-7">
          <span className="h2_800">언어 선택</span>
          <img
            className="cursor-pointer"
            src={goback}
            alt="goback"
            onClick={showLanguageSelect}
          />
        </div>

        <div className="px-7 pb-5">
          <p className="text-sm text-[#676C76] mb-4">
            원하는 언어를 선택하세요. 선택한 언어로 앱이 표시됩니다.
          </p>
        </div>
      </div>

      <div className="mt-2 bg-[#FAFCFF]">
        {languages.map((lang) => (
          <div
            key={lang.code}
            className={`flex justify-between items-center py-4 px-7 border-b border-[#E5E6E7] cursor-pointer hover:bg-[#F1F2F3] ${
              selectedLang === lang.code ? 'bg-[#E8F0FE]' : ''
            }`}
            onClick={() => !isLoading && handleLanguageChange(lang.code)}
          >
            <div className="flex flex-col">
              <span className="subtitle_2">{lang.name}</span>
              <span className="text-sm text-[#676C76]">{lang.nativeName}</span>
            </div>
            {selectedLang === lang.code && (
              <svg
                className="w-6 h-6 text-[#1B5EDC]"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M5 13l4 4L19 7"
                />
              </svg>
            )}
          </div>
        ))}
      </div>

      {isLoading && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 text-center">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#1B5EDC] mx-auto mb-3"></div>
            <p>언어를 변경하는 중...</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default LanguageSelect;
